import {useState} from "react";
import {useData} from "context/data.context";
import {useProfile} from "context/profile.context";
import NetworthCard from "../cards/networth.card";
import StackedBarsCard from "../cards/networth.bar.graph";
import WelcomeCard from "../cards/welcome.card";
import GrowthCard from "../cards/growth.card";
import FutureworthCard from "../cards/futureworth.card";
import UpdatesCard from "../cards/updates.card";
import FeedbackCard from "../cards/feedback.card";
import FeedbackPanel from "components/panels/feedback/feedback.panel"
import UpdatePanel from "components/panels/update/update.panel";
import BottomDrawer from "components/drawers/bottom.drawer";
import SideDrawer from "components/drawers/side.drawer";
import OnboardingModal from "components/onboarding/onboarding.modal";

const NetWorthPanel = () => {
  const { networthCurrent } = useData();
  const { onboardingCompleted } = useProfile();
  const isNewAccount = networthCurrent.isNew && !onboardingCompleted;

  const [openUpdatePanel, setOpenUpdatePanel] = useState(false);
  const [openFeedbackPanel, setOpenFeedbackPanel] = useState(false);
  const [showOnboarding, setShowOnboarding] = useState(false);


  return (
    <>
      {openUpdatePanel && (
        <BottomDrawer onCancel={() => setOpenUpdatePanel(false)}>
          <UpdatePanel onCancel={() => setOpenUpdatePanel(false)} />
        </BottomDrawer>
      )}

            {openFeedbackPanel && (
            <SideDrawer onCancel={() => setOpenFeedbackPanel(false)}>
              <FeedbackPanel onClose={() => setOpenFeedbackPanel(false)} />
            </SideDrawer>
      )}

      {showOnboarding && <OnboardingModal onDismiss={() => setShowOnboarding(false)} />}

      <div className="NetWorth dark">
        <div className="Header" />
        <div className="flex col large-gap ">
          <p className="xlarge padding ">Net Worth</p>

          {isNewAccount && <WelcomeCard onGetStarted={() => setShowOnboarding(true)} />}


          {!isNewAccount && (
            <>
            <NetworthCard />
              <StackedBarsCard />

              <div className="grid col-2 large-gap margin-top-large">
                <GrowthCard />
                <FutureworthCard />
                <UpdatesCard onClick={() => setOpenUpdatePanel(true)} />
                <FeedbackCard onClick={() => setOpenFeedbackPanel(true)} />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default NetWorthPanel;
